/**
 * Add endpoints of specific api calls in this file
 * 
 * for example : 
 *      {endpoint: "api/public/do_something", method: "POST", args: ["param1", "param2"] },
 * 
 * will be available in controllers as :
 *      this.api.public.do_something(param1, param2, function(err){...})
 */

 module.exports = [
    {endpoint: "api/office365/getAuthUrl", method: "POST", args: ["userId", "urlBack", {name: "authSession", optional: true}]},
    {endpoint: "api/office365/getAuthUrlWithScopes", method: "POST", args: ["userId", "urlBack", "type", "scopes"]},
    {endpoint: "api/time/getNextBusinessDay", method: "GET", args: ["days"]},
    {endpoint: "api/contact/searchSimilar", method: "GET", args: ["name"]},
    {endpoint: "api/sirene/getByName", method: "GET", args: ["name"]},
    {endpoint: "api/sirene/getBySiret", method: "GET", args: ["siret"]},
    {endpoint: "api/sireneInsee/getByName", method: "GET", args: ["name", "street", "zip", "city"]},
    {endpoint: "api/sireneInsee/getBySiret", method: "GET", args: ["siret", "mode"]},
    {endpoint: "api/customField/save", method: "POST", args: ["field"]},
    {endpoint: "api/customField/create", method: "POST", args: ["field"]},
    {endpoint: "api/customField/remove", method: "POST", args: ["id"]},
    {endpoint: "api/customField/removeModel", method: "POST", args: ["id"]},
    {endpoint: "api/customField/saveModelAndFields", method: "POST", args: ["model"]},
    {endpoint: "api/fetchmail/fetchNow", method: "POST", args: ["id"]},
    {endpoint: "api/fetchmail/test", method: "POST", args: ["id"]},
    {endpoint: "api/stats/list", method: "GET"},
    {endpoint: "api/stats/results", method: "POST", args: ["code", "params"]},
    {endpoint: "api/portal/results", method: "POST", args: ["code", "search", {name: "params", optional: true}]},
    {endpoint: "api/public/customCss", method: "GET"},
    {endpoint: "api/public/getGlobalSettings", method: "GET"},
    {endpoint: "api/public/getLocales", method: "GET", args: ["lang"]},
    {endpoint: "api/public/getShareSettings", method: "GET"},
    {endpoint: "api/public/getSharedDocument", method: "GET", args: ["token"]},
    {endpoint: "api/public/getLastTerms", method: "GET"},
    {endpoint: "api/public/getPortalModule", method: "GET"},
    {endpoint: "api/public/getPortalPartnerByActivationCode", method: "GET", args: ["token"]},
    {endpoint: "api/public/getPortalPartnerByPasswordToken", method: "GET", args: ["token"]},
    {endpoint: "api/public/activatePortalPartner", method: "POST", args: ["token", "password", "termsId"]},
    {endpoint: "api/public/sendPartnerPasswordForgot", method: "POST", args: ["login"]},
    {endpoint: "api/public/partnerRenewPassword", method: "POST", args: ["token", "password"]},
    {endpoint: "api/public/getDocForWorkflow", method: "POST", args: ["token"]},
    {endpoint: "api/public/actionDocForWorkflow", method: "POST", args: ["token", "actionId", "comment", "fields"]},
    {endpoint: "api/public/getBpmInstance", method: "POST", args: ["token"]},
    {endpoint: "api/public/getBpmForm", method: "POST", args: ["form", "instanceId"]},
    {endpoint: "api/public/bpmFormValidate", method: "POST", dataEncoding: "multipart", args: ["formId", "instanceId", "fieldValues", "file1", "file2", "file3", "file4", "file5", "file6", "file7", "file8", "file9", "file10"]},
    {endpoint: "api/public/bpmFormOpened", method: "POST", args: ["formId", "instanceId"]},
    {endpoint: "api/public/getRfqPrice", method: "GET", args: ["token"]},
    {endpoint: "api/public/getEdocSignature", method: "POST", args: ["token"]},
    {endpoint: "api/public/edocGenerateOtp", method: "POST", args: ["token"]},
    {endpoint: "api/public/edocRegenerateOtp", method: "POST", args: ["token"]},
    {endpoint: "api/public/edocSign", method: "POST", args: ["token", "stepToken","signBookId", "otp", "signImage", "paraphImg", "inputValue"]},
    {endpoint: "api/public/edocRefuse", method: "POST", args: ["token", "signBookId", "comment"]},
    {endpoint: "api/public/saveRfqPrice", method: "POST", args: ["token", "prices", "comment"]},
    {endpoint: "api/public/refuseRfqPrice", method: "POST", args: ["token", "comment"]},
    {endpoint: "api/doc/splitPdfDoc", method: "POST", args: ["docId", "docsToCreate"]},
    {endpoint: "api/doc/mergePdfDoc", method: "POST", args: ["docIds", "name"]},
    {endpoint: "api/doc/splitPdfDocFromRule", method: "POST", args: ["docId", "ruleId"]},
    {endpoint: "api/doc/rotateDoc", method: "POST", args: ["docId", "rotation"]},
    {endpoint: "api/doc/oneTimePublicUrl", method: "POST", args: ["attachId"]},
    {endpoint: "api/oauth2/start", method: "GET", args: ["client_id", "response_type", "scope"]},
    {endpoint: "api/oauth2/finish", method: "POST", args: ["transaction_id", "response_type", "client_id", "auth_url", "scope"]},
    {endpoint: "api/oauth2/createToken", method: "POST", args: ["client_id", "grant_type", "scope"]},
    {endpoint: "api/xls/exportXls", method: "POST", sendMethod: "post", dataEncoding: "multipart", args: [
        "data"
    ] },
    {endpoint: "api/ini/exportIni", method: "POST", sendMethod: "post", args: ["id"]},
    {endpoint: "api/xls/exportFormDataToExcel", method: "POST", args: [ "data" ]},
    {endpoint: "api/public/checkPassSharedDocument", method: "POST", args: ["token", {name: "password", optional: true}] },
    {endpoint: "api/public/downloadSharedDocument", method: "POST", sendMethod: "post", args: ["token", {name: "password", optional: true}] },
    {endpoint: "api/public/getSharedSearchDocuments", method: "POST", args: ["token", {name: "password", optional: true}]},
    {endpoint: "api/public/downloadSharedDocumentFromSearch", method: "POST", sendMethod: "post", args: ["token", "docId", {name: "password", optional: true}] },
    {endpoint: "api/email/createEml", method: "POST", sendMethod: "post", args: ["email_to", "subject", "html", {name: "attachments", optional: true}, {name: "as_pdf", optional: true}] },
    {endpoint: "api/dbadmin/getDatabaseList", method: "POST",  args: [ "password" ]},
    {endpoint: "api/dbadmin/listDatabaseModules", method: "GET",  args: [  ]},
    {endpoint: "api/dbadmin/listDatabaseModulesPartial", method: "GET",  args: [  ]},
    {endpoint: "api/dbadmin/updateDatabaseModules", method: "POST",  args: [ "password", "dbName", "modules" ]},
    {endpoint: "api/dbadmin/addRemoveDatabaseModules", method: "POST",  args: [ "password", "dbName", "modulesToAdd", "modulesToRemove" ]},
    {endpoint: "api/dbadmin/backupDatabase", method: "POST", sendMethod: "post",  args: [ "password", "dbName" ]},
    {endpoint: "api/dbadmin/restoreDatabase", method: "POST", dataEncoding: "multipart", args: [ "password", "dbName", "dump" ]},
    {endpoint: "api/dbadmin/deleteDatabase", method: "POST", args: [ "password", "dbName" ]},
    {endpoint: "api/dbadmin/duplicateDatabase", method: "POST", args: [ "password", "dbName", "copyName" ]},
    {endpoint: "api/dbadmin/createDatabase", method: "POST",  dataEncoding: "multipart", args: [
        "password", "dbName", "name", "modules", "logo"
    ] },
    {endpoint: "api/template/generateTemplate", method: "POST",  dataEncoding: "multipart", args: [
        "data",
        "templateId",
        "filename",
        "model",
        "recordId",
        "genPdf",
        "subTemplatesIds",
        "watermark",
    ] },
    {endpoint: "api/template/previewTemplate", method: "POST",  dataEncoding: "multipart", responseEncoding: "arraybuffer", args: [
        "data",
        "templateId",
        "filename",
        "model",
        "subTemplatesIds",
        {name: "watermark", optional: true}
    ] },
    {endpoint: "api/webdav/open", method: "POST", args: [
        "model",
        "id",
        "genPdf",
    ] },
    {endpoint: "api/camunda/deployProcess", method: "POST",  dataEncoding: "multipart", args: [
        "processId", "processCode", "file"
    ] },
    {endpoint: "api/sign/updateStatus", method: "POST", args: [ "id" ] },
    {endpoint: "api/sign/downloadSignature", method: "GET", sendMethod: "post", args: ["id"] },
    {endpoint: "api/sign/genInternalOtp", method: "GET", args: [ "id" ] },
    {endpoint: "api/sign/doInternalSign", method: "POST", args: [ "id", "otp", "signImage" ] },
    {endpoint: "api/sign/doInternalRefusal", method: "POST", args: [ "id", "comment" ] },
    {endpoint: "api/payslip/createEmployeeSafe", method: "POST", args: ["employeeIds"] }, 
    {endpoint: "api/payslip/sendSafeActivationMail", method: "POST", args: ["employeeIds"] },
    {endpoint: "api/payslip/genSafeActivationPdf", method: "POST", sendMethod: "post", args: ["employeeIds"] },
    {endpoint: "api/payslip/downloadPayslipPdf", method: "POST", sendMethod: "post", args: ["payslipIds", "filename", {name: "watermark", optional: true}, {name: "forPrint", optional: true}] },
    {endpoint: "api/payslip/downloadHrDocPdf", method: "POST", sendMethod: "post", args: ["docIds", "filename", {name: "watermark", optional: true}] },
    {endpoint: "api/payslip/downloadCertificatePdf", method: "POST", sendMethod: "post", args: ["docId", "filename"] },
    {endpoint: "api/payslip/testPayslipExtraction", method: "POST", dataEncoding: "multipart",  args: ["editionTypeId", "file"] },
    {endpoint: "api/payslip/testHrExtraction", method: "POST", dataEncoding: "multipart",  args: ["editionTypeId", "file"] },
    {endpoint: "api/payslip/analyzeFileMulti", method: "POST", dataEncoding: "multipart",  args: ["file", "pdfPassword"] },
    {endpoint: "api/payslip/analyzeFileHrMulti", method: "POST", dataEncoding: "multipart",  args: ["file", "pdfPassword"] },
    {endpoint: "api/safeadmin/getSafesByPartnerSiret", method: "POST",  args: [ "password", "siret" ]},
    {endpoint: "api/safeadmin/getSafesByPartnerName", method: "POST",  args: [ "password", "name" ]},
    {endpoint: "api/safeadmin/createSafe", method: "POST",  args: [ "password", "partner", "safe" ]},
    {endpoint: "api/safeadmin/getSafesByDatabase", method: "POST",  args: [ "password", "dbName" ]},
    {endpoint: "api/safe/getFolders", method: "POST",  args: [ "safeId", "search" ]},
    {endpoint: "api/safe/deleteFolder", method: "POST",  args: [ "safeId", "folderId" ]},
    {endpoint: "api/safe/readFolder", method: "POST",  args: [ "safeId", "folderId" ]},
    {endpoint: "api/safe/updateFolder", method: "POST",  args: [ "safeId", "folderId", "folder" ]},
    {endpoint: "api/safe/createFolder", method: "POST",  args: [ "safeId", "folder" ]},
    {endpoint: "api/safe/getDocs", method: "POST",  args: [ "safeId", "search" ]},
    {endpoint: "api/safe/deleteDoc", method: "POST",  args: [ "safeId", "docId" ]},
    {endpoint: "api/safe/readDoc", method: "POST",  args: [ "safeId", "docId" ]},
    {endpoint: "api/safe/updateDoc", method: "POST",  args: [ "safeId", "docId", "doc" ]},
    {endpoint: "api/safe/createDoc", method: "POST",  dataEncoding: "multipart", args: [ "safeId", "file", "doc" ]},
    {endpoint: "api/safe/createInvitation", method: "POST",  args: [ "safeId", "invitation" ]},
    {endpoint: "api/safe/downloadDoc", method: "POST", sendMethod: "post", args: ["safeId","docId"] },
    {endpoint: "api/safe/downloadCertificate", method: "POST", sendMethod: "post", args: ["safeId","docId"] },
    {endpoint: "api/safe/createCustomerSafe", method: "POST", args: ["customerId"] },
    {endpoint: "api/safe/createSafeFromInvitation", method: "POST", args: ["invitationUuid"] },
    {endpoint: "api/public/getSafeShareSettings", method: "GET"},
    {endpoint: "api/public/getSafeShareDocuments", method: "POST", args: ["token", "path", {name: "password", optional: true}] },
    {endpoint: "api/public/downloadSafeSharedDocument", method: "POST", sendMethod: "post", args: ["token", "docId", {name: "password", optional: true}] },
    {endpoint: "api/public/downloadDInvoice", method: "POST", sendMethod: "post", args: ["token"] },
    {endpoint: "api/public/downloadDInvoiceAttach", method: "POST", sendMethod: "post", args: ["token", "id"] },
    {endpoint: "api/public/getDInvoiceInfos", method: "POST", args: ["token"] },
    {endpoint: "api/dinvoice/testDinvoiceExtraction", method: "POST", dataEncoding: "multipart",  args: ["editionTypeId", "file"] },
    {endpoint: "api/dinvoice/testDinvoiceAttachExtraction", method: "POST", dataEncoding: "multipart",  args: ["editionTypeId", "file"] },
    {endpoint: "api/dinvoice/downloadCertificate", method: "POST", sendMethod: "post",  args: ["docId", "safeId"] },
    {endpoint: "api/dinvoice/downloadPdf", method: "POST", sendMethod: "post", args: ["docId", "safeId"] },
    {endpoint: "api/dinvoice/testChorus", method: "POST", args: ["user", "pass", "testMode"] },
    {endpoint: "api/stock/refreshFifo", method: "GET", args: [] },
    {endpoint: "api/stock/refreshAvg", method: "GET", args: [{name: "fromDate", optional: true}] },
    {endpoint: "api/public/requestTokenAccess", method: "POST", args: ["email", "app_code"] },
    {endpoint: "api/public/getTokenStatus", method: "POST", args: ["token"] },
    {endpoint: "api/public/downloadPurchaseTerms", method: "POST", sendMethod: "post", args: [] },
    {endpoint: "api/admin/deleteAll", method: "POST", args: ["code"] },
    {endpoint: "api/installpack/install", method: "POST", args: ["pack_code"] },
    {endpoint: "api/public/check_db", method: "GET", args: ["dbName"] },
    {endpoint: "api/public/getFieldDisplayFromFormUuid", method: "GET", args: ["uuid"] },
    {endpoint: "api/public/updatePublicForm", method: "POST", args: ["token", "record"] }
] ;
